export const TABLE_COLUMNS = [
  "log_time",
  "agent",
  "action",
  "previous_value",
  "new_value",
  "customer",
  "updated_agent",
  "code",
];
